import { INSTA_FOLLOWER_COUNT } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function instaFollowerCountData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case INSTA_FOLLOWER_COUNT:
    
      // const parsedData = JSON.parse(action.payload.data)
     
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}